import { LoginRequest } from './login.types';

import { API_HOST, HttpPostOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/login`;

export const getLoginRequest = (data: LoginRequest): [string, HttpPostOptions<LoginRequest>] => [
  getEndpoint(),
  getHttpPostOptions({
    email: data.email,
    password: data.password
  })
];
